import { DvaReducer } from '@/models/shared';
import { Subscription } from 'dva';
import type {
  CollectionExhibitInfoPageModelState,
  ChangeAction,
  CollectionExhibitInfoPageModelType,
} from './types';
import { initStates } from './initialState';
import { pageEffects } from './pageEffects';
import { fetchEffects } from './fetchEffects';
import { policyEffects } from './policyEffects';
import { exhibitEffects } from './exhibitEffects';
import { sideEffects } from './sideEffects';

export type { CollectionExhibitInfoPageModelState };
export * from './types';
export { handleRelation, getAllContracts } from './helpers';
export type { HandleRelationParams, HandleRelationResult } from './helpers';

const Model: CollectionExhibitInfoPageModelType = {
  namespace: 'collectionExhibitInfoPage',
  state: initStates,
  effects: {
    ...pageEffects,
    ...fetchEffects,
    ...policyEffects,
    ...exhibitEffects,
    ...sideEffects,
  },
  reducers: {
    change(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  subscriptions: {
    setup({}) {},
  },
};

export default Model;
